import React, { useState, createContext, useCallback } from 'react';

export const AlertContext = createContext();

export const AlertProvider = (props) => {
  const [alert, setAlert] = useState(null);

  const hideAlert = useCallback(() => {
    setAlert(null);
  }, []);

  const showAlert = useCallback(
    (data) => {
      setAlert(data);
      window.scrollTo(0, 0);

      setTimeout(() => {
        hideAlert();
      }, 10000);
    },
    [hideAlert]
  );

  return (
    <AlertContext.Provider value={[alert, showAlert, hideAlert]}>
      {props.children}
    </AlertContext.Provider>
  );
};
